import { type UseModalState, useModalState } from "@src/appV2/redesign/system/ui-components";

interface UseCameraPermissionSheetResult {
  cameraPermissionModalState: UseModalState;
  onCameraPermissionDenied: () => void;
}

export function useCameraPermissionSheet(): UseCameraPermissionSheetResult {
  const cameraPermissionModalState = useModalState();
  return {
    cameraPermissionModalState,
    onCameraPermissionDenied: cameraPermissionModalState.openModal,
  };
}
